<template>
    <el-dialog
            class="queryTypeModal"
            title=""
            :visible.sync="data.show"
            :close-on-click-modal="false"
            width="100%"
            @close="onClose"
            append-to-body
    >
        <div v-if="data && data.data && data.data.queryPcUrl" style="height: calc(100vh - 84px)">
            <!--<component ref="serveSearch" :is="queryPcUrl" :serveId="serveId"></component>-->
            <component :is="component" />
        </div>
    </el-dialog>

</template>

<script>
    /*当前页面是死路径的注册方法
    import MySchedule from "@/views/overseasChinese/MySchedule.vue";
    import classRoomTimetable from "@/views/overseasChinese/classRoomTimetable.vue";
    ;*/
    export default {
        name: "queryTypeModal",
        props: ["data"],
        data(){
            return{

            }
        },
        computed: {
            component() {
                // 动态路径注册，在页面服务菜单里面去配置全路径就可以了
                const queryPcUrl = this.data.data.queryPcUrl || 'views/overseasChinese/classRoomTimetable.vue';
                return () => import(`@/${queryPcUrl}`);
            },
        },
        components: {
          /*  MySchedule, // 我的课表
            classRoomTimetable, // 教室课表
           */
        },
        watch: {
            "data.show": {
                handler(val, oldVal) {
                    if (val) {
                        console.log(this.data.data);
                    }
                },
                deep: true
            }
        },
        mounted(){

        },
        methods:{
            onSubmit(){
                this.$emit("close",this.treeItem);
                this.data.show = false
            },
            onClose(){

            }
        }
    }
</script>

<style scoped lang="less">
   /* div{
        box-sizing: border-box !important;
        -moz-box-sizing: border-box !important; !* Firefox *!
        -webkit-box-sizing: border-box !important; !* Safari *!
    }*/

</style>